import React from 'react'
import { Box, TableCell } from '@mui/material'
import { CheckCircleIcon, MinusCircleIcon } from '@heroicons/react/24/solid'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { controlTowerRosterBodyCellSx, controlTowerSignalIconStyle } from './controlTowerStyles'

interface ControlTowerSignalCellProps {
  isOn: boolean
  testId: string
}

/** A roster yes / no: a green tick or a grey dash, read out as Yes or No. */
export const ControlTowerSignalCell: React.FC<ControlTowerSignalCellProps> = ({ isOn, testId }) => {
  const { t } = useTranslation()
  const label = isOn ? t('facilitator.controlTower.yes', 'Yes') : t('facilitator.controlTower.no', 'No')
  const color = isOn ? INTERAX_COLORS.green : INTERAX_COLORS.white30
  const Icon = isOn ? CheckCircleIcon : MinusCircleIcon

  return (
    <TableCell role="cell" align="center" sx={controlTowerRosterBodyCellSx}>
      <Box
        component="span"
        role="img"
        aria-label={label}
        data-testid={`${testId}-${isOn ? 'yes' : 'no'}`}
        sx={{ display: 'inline-flex', color }}
      >
        <Icon style={controlTowerSignalIconStyle} />
      </Box>
    </TableCell>
  )
}
